import {isBrandPortal} from '@netx/core-cms-next/utils/isBrandPortal';
import {categoryPermissionChecker, PermissionName, PermissionMatrixName} from '@netx/core-permissions-next';
import type {ICategory} from '../schema';

export const canRemoveAssetsFromCategory = (category?: ICategory): boolean => {
    if (category == null) return false;
    if (category.categoryid === 1) return false;
    if (isBrandPortal()) return false;
    return categoryPermissionChecker({
        category,
        permissionMatrixName: PermissionMatrixName.MODIFY,
        permissionName: PermissionName.ORGANIZE,
    });
}
